<template>
  <section id="bukaemas_more" class="o-container o-container--responsive">
    <div class="u-align-center mb-64">
      <bl-text-av tag="h2" variation="heading-32">
        {{ $options.benefits.title }}
      </bl-text-av>
    </div>
    <bl-flex-container-mv class="mb-64" style="gap: 40px">
      <bl-flex-item-av v-for="item in $options.benefits.items" :key="item.title">
        <bl-flex-item-av class="mb-5">
          <new-webp-image-container
            :src="item.image"
            :alt="item.title"
            :is-ssr="isSSR"
            styles="width: 40px; height: 40px;"
          />
        </bl-flex-item-av>
        <bl-flex-item-av>
          <bl-text-av tag="h3" variation="subheading-20" class="mb-16">
            {{ item.title }}
          </bl-text-av>
          <bl-text-av>
            {{ item.subtitle }}
          </bl-text-av>
        </bl-flex-item-av>
      </bl-flex-item-av>
    </bl-flex-container-mv>
  </section>
</template>
<script>
/* istanbul ignore file */
import BlTextAv from '@bukalapak/bazaar-dweb-2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexItemAv';
import { Benefits as benefits } from 'shared/modules/seo/Homepage';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';

export default {
  name: 'Benefits',

  benefits,

  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    NewWebpImageContainer,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },
  },
};
</script>
